import classnames from 'classnames';
import styles from './LayerToggleButton.module.css';
import { useCallback } from 'react';

export const LayerToggleButton = ({
    onToggleLayer,
    isActive,
    id,
    children,
    additionalLayers,
    isLayersLoaded,
}) => {
    const onClick = useCallback(() => {
        return isLayersLoaded ? onToggleLayer(id, additionalLayers) : () => {};
    }, [ isLayersLoaded, onToggleLayer, id, additionalLayers ]);
    return (
        <div
            onClick={onClick}
            className={classnames(styles.toggleButton, {
                [styles.active]: isActive,
                [styles.inactive]: !isActive,
                [styles.loadingLayer]: !isLayersLoaded,
            })}
        >
            {children}
        </div>
    );
};
